export default __webpack_public_path__ + "static/media/registration.56a1a67e.jpg";